import { toArray } from "lodash-es";
import { useSelector } from "react-redux";

export const useBrandsFetch = () => {
  return useSelector(({ games }) => games.brandsFetch);
};

export const useBrands = () => {
  return useSelector(({ games }) => games.brands);
};

export const useCurrentBrandId = () => {
  return useSelector(({ games }) => games.currentBrandId);
};

export const useComputedBrands = () => {
  return useSelector(({ games }) => toArray(games.computedBrands));
};
